import { render, staticRenderFns } from "./MonacoDialog.vue?vue&type=template&id=52f294b9&scoped=true"
import script from "./MonacoDialog.vue?vue&type=script&lang=ts"
export * from "./MonacoDialog.vue?vue&type=script&lang=ts"
import style0 from "./MonacoDialog.vue?vue&type=style&index=0&id=52f294b9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f294b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSpacer,VToolbar})
